module.exports = __webpack_public_path__ + "img/add-order-h.7f5f1da1.svg";